module.exports = __webpack_public_path__ + "img/M451.24f5b2bf.jpg";